<!--
 * @Author: Junjie
 * @Date: 2022-08-24 11:25:11
 * @LastEditTime: 2024-04-28 10:22:35
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-wf-web/src/views/tech/plant/modules/BaseInfo.vue
-->
<template>
  <a-spin :spinning="confirmLoading" style="background-color:#fff; height: 100%; padding: 24px 0;">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="系统名称" prop="plName">
              <a-input placeholder="请输入系统名称" v-model="model.plName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人" prop="plLeader">
              <!-- <j-select-multi-user v-model="model.plLeader"></j-select-multi-user> -->
              <j-search-select-tag
                :async="true"
                :pageSize="100"
                dict="sys_user,realname,id"
                placeholder="请选择负责人"
                tenant="rel_tenant_ids"
                v-model="model.plLeader"
              ></j-search-select-tag>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客服电话" prop="plLeaderPhone">
              <a-input placeholder="客服电话" v-model="model.plLeaderPhone"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="自定义LOGO" prop="plLogo">
              <j-image-upload class="avatar-uploader" v-model="model.plLogo"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目简介" prop="plDesc">
              <a-textarea placeholder="请输入项目简介" rows="4" v-model="model.plDesc" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <a-row>
      <a-col :span="22"></a-col>
      <a-col :span="2">
        <a-form-item>
          <a-button :loading="confirmLoading" @click="submitForm()" type="primary">保存</a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'BaseInfo',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          plStatus: "1",
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          plName: [
            { required: true, message: '请输入系统名称!' },
          ],
          plLeader: [
            { required: true, message: '请选择负责人!' },
          ],
        },
        url: {
          list: "/device/sewegePlantList/list",
          add: "/device/sewegePlantList/add",
          edit: "/device/sewegePlantList/edit",
          queryById: "/device/sewegePlantList/queryById"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.loadData();
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      loadData () {
        getAction(this.url.list, {}).then(res => {
          if (res.success) {
            const originMedel = res.result.records[0];

            if (originMedel) {

              if (!originMedel.plLeader) {
                originMedel.plLeader = this.$ls.get('Login_UserId')
              }
              this.model = originMedel;
            }
          } else {
            this.$message.error(res.message)
          }

        });
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>